import { withStyles } from "@material-ui/core";
import colors from "../styleColors"
const styles = {
  //gantt report is not using theme based colors so all styles can be defined directly here.
  cardContainer: {
    float: "left",
    fontSize: 11,
    fontWeight: 600,
    marginLeft: 40,
    color: colors.lightGrey,
  },
};
const DriverRouteCard = ({ data, classes }) => (
  <div className={classes.cardContainer}>{data.text}</div>
);

export default withStyles(styles)(DriverRouteCard);
